module.exports = __webpack_public_path__ + "static/media/button-section.eebe4ef6.png";